import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions';
import {API_URL} from '../../../constants';
import {updateValueInJson, showModalPageClass, hideModalPageClass, validateAccesoGeneral, getRoles, esUrl} from '../../../functions';
import axios from 'axios';
import ModalMultimedia from '../../Partials/ModalMultimedia';
import $ from 'jquery';

export default class AgregarCategoriaCertificacion extends Component {

    constructor(props) {
        super(props);

        this.state = {
            categoriaLongitud:0,
            resource: {
                ccer_Nombre:"",
                ccer_Icono:"",
                ccer_Orden: this.props.location.state !== undefined ? this.props.location.state.totalRegistros + 1 : "",
                ccer_Activo: true
            },
            Validacion: {
                ccer_Nombre: {
                    Error: false,
                },
                ccer_Icono: {
                    Error: false,
                },
                ccer_Orden: {
                    Error: false,
                }
            },
            hasError:false,
            hasErrorProceso:false,
            added: false,
            security: cookie.load('user'),
            roles: [],
            fieldReturnMultimedia:"",
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getResponse = this.getResponse.bind(this);

      }

    componentDidMount()
    {
        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/categorias-certificacion";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol);
    }

    getResponse = (urlSeleccionada) => {
        let resource = this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;

        if(fieldReturn!== ""){

            resource[fieldReturn] = urlSeleccionada;

            this.setState({resource:resource, fieldReturnMultimedia:""});
        }

        hideModalPageClass("divGestorArchivosCertificacion");
    }

    showModalMultimedia = (clase = "", campo = "") => {
        this.setState({fieldReturnMultimedia:campo});
        showModalPageClass(clase);
    }

    handleClickCancel(e) {
        const {history: {push}} = this.props;
        push('/categorias-certificacion');
     }

     callFunctionButton = (event) => {

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.ccer_Nombre == '') {

            newState.Validacion.ccer_Nombre = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.ccer_Icono == '' || !esUrl(newState.resource.ccer_Icono))
		{
            newState.Validacion.ccer_Icono = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.ccer_Orden == '') {
            newState.Validacion.ccer_Orden = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}CategoriaCertificacionUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'ccer_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url,
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {

            if (data.data.isSucess)
            {

                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resource.ccer_Nombre = '';
                stateResponse.resource.ccer_Orden += 1 ;
                stateResponse.resource.ccer_Icono = '';

                this.setState(stateResponse);

                setTimeout(() => {
                    this.setState({added:false});
                }, 3000);

            } else
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => {
                    this.setState({hasErrorProceso:false});
                }, 3000);
            }
        }
        ).catch((error)=> {
        toast.error('Error no controlado.');
        this.setState({loading:false});
        });
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let longitudCategoria = this.state.categoriaLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,
        }

        if(target.name == 'ccer_Nombre'){
            longitudCategoria = value.length;
        }
        this.setState({
            resource: copyResource,
            categoriaLongitud: longitudCategoria,
            Validacion: validaciones
        });
    }

    render() {
        return (
            <div className="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de Configuración General
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Agregar Categorías de Certificaciones</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Agregar Categorías de Certificaciones
                </div>

                {
                    this.state.hasErrorProceso ?
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar el registro.</div>
                        </div>
                    </div> : null
                }

                {
                    this.state.added ?
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se realizó el registro correctamente.</div>
                        </div>
                    </div>: null
                }

                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Categoría" name='ccer_Nombre' value={this.state.resource.ccer_Nombre} maxLength={25} className={this.state.Validacion.ccer_Nombre.Error ? "error" : ""}
                        onChange={this.handleInputChange}/>
                        <span data-length={25}>{this.state.categoriaLongitud}/25</span>
                    </div>
                    <div className="x-2 relative">
                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosCertificacion", "ccer_Icono")}/>
                        <input type="text" placeholder="Añadir Icono" name='ccer_Icono' value={this.state.resource.ccer_Icono} id="txtIconoCategoria" className={this.state.Validacion.ccer_Icono.Error ? "error" : ""} onChange={this.handleInputChange}/>
                        <i className="info">* El ícono debe tener formato de imagen</i>
                    </div>
                    <div className="txtFile x-2">
                        <input type="text" placeholder="Orden" name='ccer_Orden' value={this.state.resource.ccer_Orden} maxLength={2} className={this.state.Validacion.ccer_Orden.Error ? "error" : ""} onChange={this.handleInputChange} onChange={this.handleInputChange}/>
                    </div>
                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />
                <ModalMultimedia class={"divGestorArchivosCertificacion"} callback={this.getResponse.bind(this)}/>
            </div>
        )
    }
}
